import popupAlert from '@images/popup-alert.png';
import popupInfo from '@images/popup-info.png';
import popupSuccess from '@images/popup-success.png';
import popupWarning from '@images/popup-warning.png';

import { VariantName } from '../types';

export interface BaseVariantStyles {
  bgColor: string;
  titleColor: string;
  descriptionColor: string;
  buttonBgColor: string;
}

export interface BannerVariantStyles extends BaseVariantStyles {
  icon_url: string;
}

export interface PopupVariantStyles extends BaseVariantStyles {
  image_url: string;
}

export type VariantStyles = BannerVariantStyles | PopupVariantStyles;

export const BANNER_VARIANT_CONFIG: Record<VariantName, BannerVariantStyles> = {
  [VariantName.SUCCESS]: {
    bgColor: '#EAF8F2',
    icon_url: 'check-circle',
    titleColor: '#186B48',
    descriptionColor: '#595959',
    buttonBgColor: '#1E855A'
  },
  [VariantName.INFO]: {
    bgColor: '#EEF5FF',
    icon_url: 'alert-circle',
    titleColor: '#35609C',
    descriptionColor: '#667185',
    buttonBgColor: '#2663EB'
  },
  [VariantName.WARNING]: {
    bgColor: '#FEFAED',
    icon_url: 'alert-triangle',
    titleColor: '#AA612C',
    descriptionColor: '#595959',
    buttonBgColor: '#F38A3F'
  },
  [VariantName.ALERT]: {
    bgColor: '#FEECEB',
    icon_url: 'alert-triangle',
    titleColor: '#AD3026',
    descriptionColor: '#595959',
    buttonBgColor: '#CF392E'
  }
};

export const POPUP_VARIANT_CONFIG: Record<VariantName, PopupVariantStyles> = {
  [VariantName.SUCCESS]: {
    bgColor: '#FFFFFF',
    image_url: popupSuccess,
    titleColor: '#262626',
    descriptionColor: '#8C8C8C',
    buttonBgColor: '#05954E'
  },
  [VariantName.INFO]: {
    bgColor: '#FFFFFF',
    image_url: popupInfo,
    titleColor: '#262626',
    descriptionColor: '#8C8C8C',
    buttonBgColor: '#2663EB'
  },
  [VariantName.WARNING]: {
    bgColor: '#FFFFFF',
    image_url: popupWarning,
    titleColor: '#262626',
    descriptionColor: '#8C8C8C',
    buttonBgColor: '#F38A3F'
  },
  [VariantName.ALERT]: {
    bgColor: '#FFFFFF',
    image_url: popupAlert,
    titleColor: '#262626',
    descriptionColor: '#8C8C8C',
    buttonBgColor: '#CF392E'
  }
};

export const DEFAULT_VARIANT: VariantName = VariantName.INFO;
